import { override } from 'flarum/common/extend';
import AbstractGlobalSearch from 'flarum/common/components/AbstractGlobalSearch';
import Input from 'flarum/common/components/Input';
import extractText from 'flarum/common/utils/extractText';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';

/**
 * Restore the classic header search field (Input + prefix icon) instead of the
 * Flarum 2 icon-only button, matching the DIA production header.
 */
export default function registerHeaderSearchInput() {
  override(AbstractGlobalSearch.prototype, 'view', function () {
    if (this.sourceItems().isEmpty()) {
      return m("div", null);
    }
    const value = this.searchState.getValue();
    const label = extractText(this.attrs.label);
    const openSearchModal = () => {
      app.drawer.hide();
      setTimeout(() => {
        app.modal.show(() => flarum.reg.asyncModuleImport('flarum/common/components/SearchModal'), {
          searchState: this.searchState,
          sources: this.sourceItems().toArray()
        });
      }, 150);
    };
    return m("div", {
      role: "search",
      className: classList('Search', {
        'Search--active': !!value
      }),
      "aria-label": this.attrs.a11yRoleLabel,
      onclick: openSearchModal,
      onkeydown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openSearchModal();
        }
      }
    }, m(Input, {
      className: "Search-input",
      type: "search",
      prefixIcon: "fas fa-search",
      placeholder: label,
      value: value,
      readonly: true,
      ariaLabel: value || label,
      inputAttrs: {
        title: value || label,
        tabindex: 0
      }
    }));
  });
}
flarum.reg.add('dia-theme', 'forum/features/header-search-input', registerHeaderSearchInput);